export default {
    install(app, options = {}) {
        let isInIFrame = false;
        try {
            isInIFrame = window.self !== window.top;
        }
        catch (err) {
            isInIFrame = true;
        }
        app.provide("$isFrame", isInIFrame);
    }
};
